import React from 'react';
import styles from "./../Pages/Login/Login.module.scss"
import Card from "../Components/Atoms/Card/Card";

const SubscriptionPlans = () => {
  return (
    <div className={styles.card} autoComplete="off">
      
    <div className="container my-5">
      <div className="row">
        {/* Plan 1 */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-lg">
            <div className="card-body text-center">
              <h5 className="card-title">Basic Plan</h5>
              <h6 className="card-subtitle mb-2 text-muted">$10 / month</h6>
              <p className="card-text">Perfect for individuals who need basic features.</p>
              <ul className="list-unstyled">
                <li>1 User</li>
                <li>5GB Storage</li>
                <li>Email Support</li>
              </ul>
              <button className="btn btn-primary">Select Plan</button>
            </div>
          </div>
        </div>

        {/* Plan 2 */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-lg">
            <div className="card-body text-center">
              <h5 className="card-title">Standard Plan</h5>
              <h6 className="card-subtitle mb-2 text-muted">$20 / month</h6>
              <p className="card-text">For growing businesses and teams.</p>
              <ul className="list-unstyled">
                <li>5 Users</li>
                <li>50GB Storage</li>
                <li>Priority Support</li>
              </ul>
              <button className="btn btn-primary">Select Plan</button>
            </div>
          </div>
        </div>

        {/* Plan 3 */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-lg">
            <div className="card-body text-center">
              <h5 className="card-title">Premium Plan</h5>
              <h6 className="card-subtitle mb-2 text-muted">$50 / month</h6>
              <p className="card-text">For large teams and advanced features.</p>
              <ul className="list-unstyled">
                <li>Unlimited Users</li>
                <li>1TB Storage</li>
                <li>24/7 Support</li>
              </ul>
              <button className="btn btn-primary">Select Plan</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
 </div>
  );
};

export default SubscriptionPlans;
